var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");

var SymbolGeneratorInteractionView = require("./symbolGeneratorInteractionView.js");
var SymbolGeneratorInteractionModel = require("./symbolGeneratorInteractionModel.js");

var SymbolGeneratorViewerController = function(archLayers, dependencies, configuration) {
    editor_2d.AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SymbolGeneratorViewerController, editor_2d.AbstractViewerController);
SymbolGeneratorViewerController.inject = lib_core.clone(editor_2d.AbstractViewerController.inject);

module.exports = SymbolGeneratorViewerController;

SymbolGeneratorViewerController.prototype.beforeLoad = function () {
    editor_2d.AbstractViewerController.prototype.beforeLoad.call(this);
};

SymbolGeneratorViewerController.prototype.getDataType = function () {
    return cio_datamodel.SymbolGeneratorData;
};

SymbolGeneratorViewerController.prototype.getInteractionViewType = function () {
    return SymbolGeneratorInteractionView;
};

SymbolGeneratorViewerController.prototype.getInteractionModelType = function () {
    return SymbolGeneratorInteractionModel;
};

